// --- React
import { useContext, useReducer } from 'react';
// --- Context
import { DialogsCtx } from './context';
// --- State Management
import { ACTION_TYPES, dialogsReducer, initialState } from './duck';

/**
 * useDialogsCtxBuilder
 *
 * This hook is responsible for managing the state of dialogs in the application.
 * It uses the useReducer hook to manage the dialogs state and provides functions to open and close dialogs.
 *
 * @returns {Object} An object containing the dialogs state and actions to manage it.
 */
export const useDialogsCtxBuilder = () => {
    const [state, dispatch] = useReducer(dialogsReducer, initialState);

    // Function to open a dialog
    const openDialog = (dialog) =>
        dispatch({
            type: ACTION_TYPES.OPEN,
            payload: {
                ...dialog,
                uid: window.crypto.randomUUID(),
            },
        });

    // Function to close a dialog
    const closeDialog = () => dispatch({ type: ACTION_TYPES.CLOSE });

    return {
        dialogs: state,
        actions: { openDialog, closeDialog },
    };
};

/**
 * useDialogsCtx Hook
 *
 * This hook provides access to the dialogs context.
 * It returns the dialogs state and actions to manage it.
 *
 *  @returns {Object} An object containing the dialogs state and actions.
 */
export const useDialogsActions = () => useContext(DialogsCtx).actions;
